function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from 'react';
import { compose, withProps, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { notesPublicTotalCount, notesPrivateTotalCount, applicationIsModifiedSelector } from "../../../store/selectors/application";
import { applicationCurrentApplicationSelector } from '@applyboard/ab-common';
import { applicationCustomFieldsEnhancer } from "../enhancer";
import tabSelectorEnhancer from "../enhancer/tabSelectorEnhancer";
import { getStudentCustomFieldsAction, getApplicationCustomFieldsAction } from "../../../api/jsonapi";
import lazyLoad from "../../../util/lazyLoad";
import componentErrorBoundary from "../../../components/enhancers/componentErrorBoundary";
import handleApiErrorResponse from "../../../util/handleApiErrorResponse";
import buildObjectListCached from "../../../util/buildObjectListCached";
import withInitialProps from "../../../components/InitialPropsContext/enhancer";
import TabSelector from "./TabSelector";
import ApplicationRequirementsHeader from "../Requirements/ApplicationRequirementsHeader/ApplicationRequirementsHeader";
import CustomFieldsTabBar from "../../../components/CustomFields/CustomFieldsTabBar";
import NoteTabBar from "./NoteTabBar";
// TODO: move preview requirements to its own tab array and apply permissions to it
var tabList = [{
  icon: 'file-text',
  label: 'Applicant Requirements',
  detailComponent: ApplicationRequirementsHeader
}, {
  icon: '',
  label: 'Preview Requirements',
  detailComponent: ApplicationRequirementsHeader,
  props: {
    privateOnly: true,
    preview: true
  }
}];
var actionsTab = [{
  icon: 'internal-icon',
  label: 'Actions',
  detailComponent: ApplicationRequirementsHeader
}];
var createPublicNotesExtraTabs = function createPublicNotesExtraTabs(canCreateBulkNote, isMarkdownRendererEnabled) {
  return [{
    icon: 'comments',
    label: 'Notes',
    detailComponent: NoteTabBar,
    props: {
      publicOnly: true,
      canCreateBulkNote: canCreateBulkNote,
      isMarkdownRendererEnabled: isMarkdownRendererEnabled
    }
  }];
};
var createPrivateNotesExtraTabs = function createPrivateNotesExtraTabs(canCreateBulkNote, isMarkdownRendererEnabled) {
  return [{
    icon: 'comment-alt',
    label: 'Admin Comments',
    detailComponent: NoteTabBar,
    props: {
      privateOnly: true,
      canCreateBulkNote: canCreateBulkNote,
      isMarkdownRendererEnabled: isMarkdownRendererEnabled
    }
  }];
};
var customFieldsExtraTab = [{
  icon: 'comment-alt',
  label: 'Application Details',
  detailComponent: CustomFieldsTabBar,
  props: {
    privateOnly: true
  }
}];
var studentRecordsTab = [{
  icon: 'student-records',
  label: 'Student Records'
}];
var commissionTab = [{
  icon: 'dollar',
  label: 'Commission'
}];
var getCustomFields = buildObjectListCached('custom_fields');
var enhancer = compose(componentErrorBoundary, tabSelectorEnhancer, applicationCustomFieldsEnhancer, connect(createStructuredSelector({
  public_notes_count: notesPublicTotalCount,
  private_notes_count: notesPrivateTotalCount,
  custom_fields: getCustomFields,
  isModified: applicationIsModifiedSelector,
  application: applicationCurrentApplicationSelector
})), lazyLoad('student_custom_fields', getStudentCustomFieldsAction, function (func, _ref) {
  var studentId = _ref.studentId;
  return func({
    id: studentId
  });
}, function (_ref2) {
  var request = _ref2.request,
    studentId = _ref2.studentId,
    permissions = _ref2.permissions;
  return (!request || !request.hasStarted) && !!studentId && (permissions === null || permissions === void 0 ? void 0 : permissions.show_custom_field_student);
}, handleApiErrorResponse), lazyLoad('application_custom_fields', getApplicationCustomFieldsAction, function (func, _ref3) {
  var applicationId = _ref3.applicationId;
  return func({
    id: applicationId
  });
}, function (_ref4) {
  var request = _ref4.request,
    applicationId = _ref4.applicationId,
    permissions = _ref4.permissions;
  return (!request || !request.hasStarted) && !!applicationId && (permissions === null || permissions === void 0 ? void 0 : permissions.show_custom_field_application);
}, handleApiErrorResponse), withInitialProps('initialProps'),
// eslint-disable-next-line camelcase
withProps(function (_ref5) {
  var initialProps = _ref5.initialProps,
    public_notes_count = _ref5.public_notes_count,
    private_notes_count = _ref5.private_notes_count,
    isModified = _ref5.isModified;
  return {
    public_notes_count: public_notes_count || (initialProps === null || initialProps === void 0 ? void 0 : initialProps.notes_count) || 0,
    // eslint-disable-line camelcase
    private_notes_count: private_notes_count || (initialProps === null || initialProps === void 0 ? void 0 : initialProps.private_notes_count) || 0,
    // eslint-disable-line camelcase
    isModified: isModified || (initialProps === null || initialProps === void 0 ? void 0 : initialProps.application_is_modified) || false
  };
}), withProps(function (_ref6) {
  var application = _ref6.application,
    custom_fields = _ref6.custom_fields,
    permissions = _ref6.permissions,
    private_notes_count = _ref6.private_notes_count,
    public_notes_count = _ref6.public_notes_count,
    set_tab = _ref6.set_tab,
    onSidebarOpenChange = _ref6.onSidebarOpenChange,
    reloadAggregatedData = _ref6.reloadAggregatedData,
    showPreviewButton = _ref6.showPreviewButton,
    hideLegacyNoteTabBar = _ref6.hideLegacyNoteTabBar,
    hideApplicationRequirementsHeader = _ref6.hideApplicationRequirementsHeader,
    hideAdminRequirementsHeader = _ref6.hideAdminRequirementsHeader,
    showNewAdminRequirementTab = _ref6.showNewAdminRequirementTab,
    canCreateBulkNote = _ref6.canCreateBulkNote,
    isMarkdownRendererEnabled = _ref6.isMarkdownRendererEnabled,
    showCommissionTab = _ref6.showCommissionTab;
  var list = tabList;
  if (permissions !== null && permissions !== void 0 && permissions.show_actions_tab) {
    list = [].concat(_toConsumableArray(list), actionsTab);
  }
  if (permissions !== null && permissions !== void 0 && permissions.view_student_records) {
    list = [].concat(_toConsumableArray(list), studentRecordsTab);
  }
  if (permissions !== null && permissions !== void 0 && permissions.index_public_note) {
    list = [].concat(_toConsumableArray(list), _toConsumableArray(createPublicNotesExtraTabs(canCreateBulkNote, isMarkdownRendererEnabled)));
  }
  if (permissions !== null && permissions !== void 0 && permissions.index_private_note) {
    list = [].concat(_toConsumableArray(list), _toConsumableArray(createPrivateNotesExtraTabs(canCreateBulkNote, isMarkdownRendererEnabled)));
  }
  if (permissions !== null && permissions !== void 0 && permissions.show_custom_field_student || permissions !== null && permissions !== void 0 && permissions.show_custom_field_application) {
    list = [].concat(_toConsumableArray(list), customFieldsExtraTab);
  }
  if (showCommissionTab) {
    list = [].concat(_toConsumableArray(list), commissionTab);
  }
  list = list.map(function (entry) {
    if (entry.label === 'Applicant Requirements') {
      var updatedEntry = _objectSpread({}, entry);
      if (hideApplicationRequirementsHeader) {
        delete updatedEntry.detailComponent;
      }
      return _objectSpread(_objectSpread({}, updatedEntry), {}, {
        props: _objectSpread(_objectSpread({}, entry.props), {}, {
          set_tab: set_tab,
          application: application,
          onSidebarOpenChange: onSidebarOpenChange,
          reloadAggregatedData: reloadAggregatedData,
          showPreviewButton: showPreviewButton
        })
      });
    }
    if (entry.label === 'Actions') {
      var _updatedEntry = _objectSpread(_objectSpread({}, entry), {}, {
        label: showNewAdminRequirementTab ? 'Admin Requirements' : 'Actions',
        detailComponent: hideAdminRequirementsHeader ? undefined : entry.detailComponent
      });
      return _objectSpread(_objectSpread({}, _updatedEntry), {}, {
        props: _objectSpread(_objectSpread({}, entry.props), {}, {
          set_tab: set_tab,
          reloadAggregatedData: reloadAggregatedData
        })
      });
    }
    if (entry.label === 'Preview Requirements') return _objectSpread(_objectSpread({}, entry), {}, {
      props: _objectSpread(_objectSpread({}, entry.props), {}, {
        set_tab: set_tab,
        onSidebarOpenChange: onSidebarOpenChange,
        showPreviewButton: showPreviewButton
      })
    });
    if (entry.label === 'Notes') return _objectSpread(_objectSpread({}, entry), {}, {
      props: _objectSpread(_objectSpread({}, entry.props), {}, {
        count: public_notes_count,
        userPermissions: permissions,
        hideLegacyNoteTabBar: hideLegacyNoteTabBar
      })
    });
    if (entry.label === 'Admin Comments') return _objectSpread(_objectSpread({}, entry), {}, {
      props: _objectSpread(_objectSpread({}, entry.props), {}, {
        count: private_notes_count,
        userPermissions: permissions,
        hideLegacyNoteTabBar: hideLegacyNoteTabBar
      })
    });
    if (entry.label === 'Application Details') return _objectSpread(_objectSpread({}, entry), {}, {
      props: _objectSpread(_objectSpread({}, entry.props), {}, {
        count: custom_fields.length,
        enableAddCustomFields: (permissions === null || permissions === void 0 ? void 0 : permissions.create_custom_field_student) || (permissions === null || permissions === void 0 ? void 0 : permissions.create_custom_field_application)
      })
    });
    if (entry.label === 'Student Records') return _objectSpread(_objectSpread({}, entry), {}, {
      props: _objectSpread(_objectSpread({}, entry.props), {}, {
        set_tab: set_tab
      })
    });
    return entry;
  });
  return {
    tab_list: list
  };
}), withProps(function (_ref7) {
  var tab_list = _ref7.tab_list,
    selected_tab = _ref7.selected_tab,
    showNewAdminRequirementTab = _ref7.showNewAdminRequirementTab;
  if (selected_tab === 'Actions' || selected_tab === 'Admin Requirements') {
    selected_tab = showNewAdminRequirementTab ? 'Admin Requirements' : 'Actions';
  }
  var currentTab = !selected_tab && tab_list.length > 0 ? tab_list[0].label : selected_tab;
  var selectedIndex = currentTab && tab_list.length > 0 ? tab_list.findIndex(function (entry) {
    return entry.label.toLowerCase() === currentTab.toLowerCase();
  }) : -1;
  var selectedTabObject = currentTab && tab_list.length > 0 ? tab_list.find(function (entry) {
    return entry.label.toLowerCase() === currentTab.toLowerCase();
  }) || null : null;
  var detailProps = (selectedTabObject === null || selectedTabObject === void 0 ? void 0 : selectedTabObject.props) || {};
  var detail = selectedTabObject && selectedTabObject.detailComponent ? /*#__PURE__*/React.createElement(selectedTabObject.detailComponent, detailProps) : null;
  return {
    currentTab: currentTab,
    selectedIndex: selectedIndex,
    detail: detail
  };
}), setPropTypes({
  currentTab: PropTypes.string,
  detail: PropTypes.object,
  note_count: PropTypes.number,
  notes: PropTypes.arrayOf(PropTypes.shape({
    attachments: PropTypes.array,
    author: PropTypes.object,
    body: PropTypes.string,
    created_at: PropTypes.string,
    id: PropTypes.number,
    title: PropTypes.string,
    visibility: PropTypes.string
  })),
  permissions: PropTypes.object,
  private_notes_count: PropTypes.number,
  public_notes_count: PropTypes.number,
  selectedIndex: PropTypes.number,
  selected_tab: PropTypes.string,
  set_tab: PropTypes.func,
  tab_list: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    detail: PropTypes.string,
    icon: PropTypes.string,
    detailComponent: PropTypes.func,
    props: PropTypes.object
  }))
}));
export default enhancer(TabSelector);